export function removeParams() {
    return {
        created_at_from: undefined,
        created_at_to: undefined
    };
};
